(() => {
  'use strict';
  const root = document.querySelector('[data-compare-discovery]');
  const records = window.JoottiCompareDiscoveryData;
  if (!root || !Array.isArray(records)) return;

  const categories = {
    rods: [
      ['bfs-casting', 'BFS casting'], ['trout-stream', 'Trout & stream BFS'],
      ['finesse-spinning', 'Finesse spinning'], ['versatile-casting', 'Versatile casting'],
      ['bottom-contact', 'Bottom contact'], ['moving-bait', 'Jerkbait & moving bait'],
      ['crankbait-glass', 'Crankbait & glass'], ['big-bait', 'Big bait & umbrella rigs']
    ],
    reels: [
      ['bfs-reels', 'BFS shallow spool'], ['compact-70', 'Compact 70 / light lure'],
      ['compact-100', 'Compact 70–100'], ['casting-150', '150-size casting'],
      ['casting-200', '200-size power'], ['spinning-2500', 'Spinning 2500'],
      ['spinning-3000', 'Spinning C3000 / 3000']
    ]
  };
  const stage = (name) => root.querySelector(`[data-jcd-stage="${name}"]`);
  const status = root.querySelector('[data-jcd-status]');
  const sourceSelect = root.querySelector('[data-jcd-source]');
  const sourceCard = root.querySelector('[data-jcd-source-card]');
  const partnerList = root.querySelector('[data-jcd-partners]');
  const openButton = root.querySelector('[data-jcd-open]');
  const result = root.querySelector('[data-jcd-result]');
  const mount = root.querySelector('[data-jcd-mount]');
  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  };
  const state = { kind: null, category: null, source: null, partner: null, panel: null, choices: [] };
  const cache = new Map();
  let requestNumber = 0;
  const emit = (event, detail) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  };
  const categoryLabel = (kind, key) => categories[kind]?.find(([id]) => id === key)?.[1] || key;
  const setStatus = (message) => { status.textContent = message; };
  const clearResult = () => { result.hidden = true; mount.replaceChildren(); };
  const shareUrl = (sourceId, partnerId) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('a');
    url.searchParams.delete('b');
    if (sourceId) url.searchParams.set('a', sourceId);
    if (partnerId) url.searchParams.set('b', partnerId);
    url.hash = '';
    return url.pathname + url.search;
  };
  const chooseKind = (kind, options = {}) => {
    if (!categories[kind]) return;
    state.kind = kind;
    state.category = null;
    state.source = null;
    state.partner = null;
    state.panel = null;
    state.choices = [];
    clearResult();
    stage('category').hidden = false;
    stage('source').hidden = true;
    stage('partner').hidden = true;
    sourceCard.hidden = true;
    setStatus('');
    root.querySelectorAll('[data-jcd-kind]').forEach((link) => {
      if (link.dataset.jcdKind === kind) link.setAttribute('aria-current', 'step');
      else link.removeAttribute('aria-current');
    });
    const heading = root.querySelector('#jcd-category-heading');
    heading.textContent = kind === 'rods' ? 'Choose a curated comparison category' : 'Choose a reel platform';
    const group = root.querySelector('[data-jcd-categories]');
    group.replaceChildren();
    categories[kind].forEach(([key, label]) => {
      const count = records.filter((item) => item.kind === kind && item.category === key).length;
      if (!count) return;
      const button = make('button', 'jcd__category');
      button.type = 'button';
      button.dataset.jcdCategory = key;
      button.setAttribute('aria-pressed', 'false');
      button.append(make('span', '', label), make('small', '', `${count} curated models`));
      group.append(button);
    });
    if (options.track) emit('compare_category_selected', { compare_kind: kind, category: kind });
    if (options.focus) { stage('category').scrollIntoView({ block: 'start' }); heading.focus({ preventScroll: true }); }
  };
  const chooseCategory = (key, options = {}) => {
    if (!state.kind || !categories[state.kind].some(([id]) => id === key)) return;
    state.category = key;
    state.source = null;
    state.partner = null;
    state.panel = null;
    state.choices = [];
    clearResult();
    stage('source').hidden = false;
    stage('partner').hidden = true;
    sourceCard.hidden = true;
    setStatus('');
    root.querySelectorAll('[data-jcd-category]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.jcdCategory === key)));
    root.querySelector('#jcd-source-heading').textContent = state.kind === 'rods' ? 'Choose your rod' : 'Choose your reel';
    sourceSelect.replaceChildren(make('option', '', 'Choose an exact model'));
    sourceSelect.options[0].value = '';
    records.filter((item) => item.kind === state.kind && item.category === key).forEach((item) => {
      const label = [item.model, item.family].filter(Boolean).join(' · ');
      const option = make('option', '', `${label} · ${money(item.priceCents)}`);
      option.value = item.id;
      sourceSelect.append(option);
    });
    if (options.track) emit('compare_category_selected', { compare_kind: state.kind, category: key });
    if (options.focus) { stage('source').scrollIntoView({ block: 'start' }); sourceSelect.focus({ preventScroll: true }); }
  };
  const identity = (card) => {
    const parts = [...card.querySelectorAll('.jootti-compare__identity-series,.jootti-compare__identity-model')].map((node) => node.textContent.trim()).filter(Boolean);
    return parts.length ? parts.join(' · ') : (card.querySelector('.jootti-compare__card-title')?.textContent.trim() || 'Curated alternative');
  };
  const loadSource = async (item) => {
    if (cache.has(item.id)) return cache.get(item.id);
    const url = new URL(`/products/${encodeURIComponent(item.handle)}`, window.location.origin);
    url.searchParams.set('variant', item.id);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('This product is temporarily unavailable. Choose another model.');
    const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
    const panel = [...documentCopy.querySelectorAll('[data-compare-variant]')].find((node) => node.dataset.compareVariant === item.id && node.dataset.comparePublished === 'true');
    if (!panel) throw new Error('This model no longer has a published comparison. Choose another model.');
    const choices = [...panel.querySelectorAll('[data-compare-partner]')]
      .filter((pair) => pair.dataset.partnerPublished === 'true' && pair.dataset.partnerAvailable === 'true')
      .map((pair) => {
        const card = pair.querySelector('.jootti-compare__card--b');
        return {
          id: pair.dataset.comparePartner,
          name: identity(card),
          price: pair.dataset.partnerPrice || card.querySelector('.jootti-compare__price')?.textContent.trim() || '',
          bestFor: card.querySelector('.jootti-compare__best-for')?.textContent.trim() || '',
          priceCents: Number(card.dataset.comparePriceCents || 0)
        };
      });
    const loaded = { panel, choices };
    cache.set(item.id, loaded);
    return loaded;
  };
  const choosePartner = (id, options = {}) => {
    const choice = state.choices.find((item) => item.id === id);
    if (!choice) return false;
    state.partner = choice;
    root.querySelectorAll('[name="jcd-partner"]').forEach((radio) => { radio.checked = radio.value === id; });
    openButton.disabled = false;
    if (options.track) emit('compare_matchup_selected', {
      source_variant_id: state.source.id,
      comparison_variant_id: id,
      compare_group: state.source.group,
      source_price_cents: state.source.priceCents,
      comparison_price_cents: choice.priceCents
    });
    return true;
  };
  const selectSource = async (id, options = {}) => {
    const item = records.find((record) => record.id === id && record.kind === state.kind && record.category === state.category);
    if (!item) return false;
    const thisRequest = ++requestNumber;
    state.source = item;
    state.partner = null;
    state.panel = null;
    state.choices = [];
    clearResult();
    stage('partner').hidden = true;
    sourceCard.hidden = true;
    sourceSelect.value = item.id;
    setStatus('Checking Jootti’s current curated partners…');
    if (options.track) emit('compare_source_selected', { compare_kind: item.kind, category: item.category, source_variant_id: item.id });
    try {
      const loaded = await loadSource(item);
      if (thisRequest !== requestNumber) return false;
      state.panel = loaded.panel;
      state.choices = loaded.choices;
      const source = loaded.panel.querySelector('.jootti-compare__card:not(.jootti-compare__card--b)');
      sourceCard.replaceChildren();
      sourceCard.append(make('strong', '', source ? identity(source) : [item.family, item.model].filter(Boolean).join(' · ')));
      sourceCard.append(make('span', '', source?.querySelector('.jootti-compare__price')?.textContent.trim() || money(item.priceCents)));
      sourceCard.append(make('p', '', source?.querySelector('.jootti-compare__best-for')?.textContent.trim() || item.subgroup));
      sourceCard.hidden = false;
      partnerList.replaceChildren();
      if (!loaded.choices.length) {
        setStatus('No available curated partner remains for this model. Choose another product.');
        return false;
      }
      loaded.choices.forEach((choice) => {
        const label = make('label', 'jcd__partner');
        const radio = make('input');
        radio.type = 'radio'; radio.name = 'jcd-partner'; radio.value = choice.id;
        const copy = make('span');
        copy.append(make('strong', '', choice.name), make('em', '', choice.price), make('small', '', choice.bestFor));
        label.append(radio, copy);
        partnerList.append(label);
      });
      openButton.disabled = true;
      stage('partner').hidden = false;
      if (options.partnerId && !choosePartner(options.partnerId)) {
        setStatus('That exact pair is no longer a valid curated comparison. Choose one of the current options.');
        return false;
      }
      if (!options.partnerId && loaded.choices.length === 1) choosePartner(loaded.choices[0].id, { track: options.track });
      setStatus('');
      if (options.focus) { stage('partner').scrollIntoView({ block: 'start' }); root.querySelector('#jcd-partner-heading').focus?.({ preventScroll: true }); }
      return true;
    } catch (error) {
      if (thisRequest !== requestNumber) return false;
      setStatus(error.message || 'The comparison could not load. Choose another product.');
      return false;
    }
  };
  const renderComparison = (options = {}) => {
    if (!state.source || !state.partner || !state.panel) return;
    const valid = new Set(state.choices.map((choice) => choice.id));
    const panel = document.importNode(state.panel, true);
    panel.querySelectorAll('[data-compare-partner]').forEach((pair) => {
      if (!valid.has(pair.dataset.comparePartner)) pair.remove();
      else pair.hidden = pair.dataset.comparePartner !== state.partner.id;
    });
    const switcher = panel.querySelector('[data-compare-switch]');
    if (switcher) {
      [...switcher.options].forEach((option) => { if (!valid.has(option.value)) option.remove(); });
      switcher.value = state.partner.id;
      if (valid.size === 1) {
        panel.querySelector('[data-compare-chooser]')?.remove();
        panel.querySelector('[data-compare-another]')?.remove();
      }
    }
    const pair = panel.querySelector('[data-compare-partner]:not([hidden])');
    const introPrice = panel.querySelector('[data-compare-intro-price]');
    const introBest = panel.querySelector('[data-compare-intro-best]');
    if (introPrice && pair) introPrice.textContent = pair.dataset.partnerPrice || '';
    if (introBest && pair) introBest.textContent = pair.dataset.partnerBest || '';
    const partnerLink = pair?.querySelector('.jootti-compare__card--b .jootti-compare__view');
    const shopB = panel.querySelector('[data-compare-shop-b]');
    if (shopB && partnerLink) {
      shopB.href = partnerLink.href;
      shopB.textContent = `SHOP B · ${state.partner.name}`;
      shopB.setAttribute('aria-label', `Shop exact product B: ${state.partner.name}`);
    }
    const compare = make('div', 'jootti-compare');
    compare.id = 'jootti-compare';
    compare.tabIndex = -1;
    compare.dataset.joottiCompare = '';
    compare.dataset.compareHub = 'true';
    compare.dataset.initialVariant = state.source.id;
    compare.append(panel);
    if (options.push) history.pushState({ joottiCompare: true }, '', shareUrl(state.source.id, state.partner.id));
    mount.replaceChildren(compare);
    result.hidden = false;
    window.JoottiCompare?.mount?.(compare);
    compare.addEventListener('change', (event) => {
      const selected = event.target.closest('[data-compare-switch]');
      if (!selected || !choosePartner(selected.value, { track: true })) return;
      history.replaceState({ joottiCompare: true }, '', shareUrl(state.source.id, state.partner.id));
    });
    setStatus('');
    if (options.focus) { result.scrollIntoView({ block: 'start' }); root.querySelector('#jcd-result-heading').focus({ preventScroll: true }); }
  };
  const restoreUrl = async () => {
    const url = new URL(window.location.href);
    const a = url.searchParams.get('a');
    const b = url.searchParams.get('b');
    if (!a && !b) {
      clearResult();
      if (url.hash === '#compare-rods' || url.hash === '#compare-reels') chooseKind(url.hash.slice(9), { focus: true });
      return;
    }
    const item = records.find((record) => record.id === a);
    if (!item || !b || !/^\d+$/.test(a) || !/^\d+$/.test(b)) {
      history.replaceState({}, '', shareUrl(null, null));
      chooseKind('rods');
      setStatus('That matchup link is not valid. Start with a rod or reel.');
      return;
    }
    chooseKind(item.kind);
    chooseCategory(item.category);
    const valid = await selectSource(item.id, { partnerId: b });
    if (!valid) {
      history.replaceState({}, '', shareUrl(null, null));
      return;
    }
    renderComparison({ focus: false });
  };

  root.querySelectorAll('[data-jcd-kind]').forEach((link) => link.addEventListener('click', (event) => {
    event.preventDefault();
    history.replaceState({}, '', `${shareUrl(null, null)}#compare-${link.dataset.jcdKind}`);
    chooseKind(link.dataset.jcdKind, { focus: true, track: true });
  }));
  root.querySelector('[data-jcd-categories]').addEventListener('click', (event) => {
    const button = event.target.closest('[data-jcd-category]');
    if (button) chooseCategory(button.dataset.jcdCategory, { focus: true, track: true });
  });
  sourceSelect.addEventListener('change', () => {
    if (sourceSelect.value) selectSource(sourceSelect.value, { focus: true, track: true });
    else { ++requestNumber; stage('partner').hidden = true; sourceCard.hidden = true; clearResult(); }
  });
  partnerList.addEventListener('change', (event) => {
    if (event.target.name === 'jcd-partner') choosePartner(event.target.value, { track: true });
  });
  openButton.addEventListener('click', () => renderComparison({ push: true, focus: true }));
  root.querySelector('[data-jcd-change]').addEventListener('click', (event) => {
    event.preventDefault();
    history.pushState({}, '', shareUrl(null, null) + '#compare-builder');
    clearResult();
    stage('source').scrollIntoView({ block: 'start' });
    sourceSelect.focus({ preventScroll: true });
  });
  window.addEventListener('popstate', restoreUrl);
  restoreUrl();
})();

